<template>
  <input-select ref="select" v-model="value" caption="Выберите тип рейса..." :itemList="items"></input-select>
</template>

<script>
export default {
  props: ['model-value'],
  emits: ['update:model-value'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
      }
    },
    items() {
      return this.$store.getters['getRaces'].map(item => {
        return {
          id: item.raceId,
          title: item.raceTitle + " (" + item.raceType + ")"
        }
      });

    }
  },
  methods: {
    validate() {
      return this.$refs.select.validate()
    }
  }
}
</script>
